<template>
  <b-tab
    :title="store.permitirServicosOrcamento ? 'Produtos e Serviços' : 'Produtos'"
    :active="isTheCurrentTab"
    @click="() => (store.currentTab = produtoTabIndex)"
    :disabled="!isTheCurrentTab && !store.isUpdate"
  >
    <b-row align-v="center" class="orcamento-item-search">
      <b-col md="10">
        <b-form-group label="Nome" label-for="name">
          <VueSelect
            ref="buscarProduto"
            :filterable="false"
            :get-option-key="getItemKey"
            @input="setProduto"
            :options="produtosFetched"
            :class="{ hasErrors: produtoError, inputFilled: produtoFilled }"
            @search="onSearchProduto"
            v-model="descricao"
          >
            <template slot="no-options"> Informe o item pelo nome </template>
            <template slot="option" slot-scope="option">
              <div class="d-flex justify-content-between">
                <div>
                  <div>
                    <span v-if="store.permitirServicosOrcamento" class="badge badge-light mr-2">{{ option.tipo === "servico" ? "Serviço" : "Produto" }}</span>
                    {{ option.tipo === "servico" ? option.id_servico : option.codigo }} - {{ option.tipo === "servico" ? option.discriminacao : option.descricao }}
                    <span
                      id="kitInfo"
                      v-if="option.isKit"
                      :title="getKitInfo(option)"
                      v-b-tooltip.hover.html.right
                    >
                      <InformationOutline :size="14" />
                    </span>
                  </div>
                  <small v-if="option.referencia">
                    Referência: {{ option.referencia }}
                  </small>
                </div>
                <span v-if="option.tipo === 'servico'">R$ {{ numberToReal(option.valor, "preco") }}</span>
                <span
                  v-else-if="
                    option.preco_atacado > 0 && !option.preco_lista_cliente
                  "
                  >{{
                    option.preco_atacado
                      ? `QTD: ${option.quantidade} R$: ${numberToReal(
                          option.preco
                        )} Atacado: ${numberToReal(option.preco_atacado)}`
                      : `R$
                  ${numberToReal(option.totalPrice)}`
                  }}</span
                >
                <span
                  v-else-if="
                    option.preco_lista_cliente && option.preco_lista_cliente > 0
                  "
                  >{{
                    option.preco_lista_cliente
                      ? `QTD: ${option.quantidade} R$: ${numberToReal(
                          option.preco_lista_cliente
                        )}`
                      : `R$
                  ${numberToReal(option.totalPrice)}`
                  }}</span
                >
                <span v-else>{{
                  !option.isKit
                    ? `QTD: ${option.quantidade}, R$: ${numberToReal(
                        option.preco
                      )}`
                    : `R$
                  ${numberToReal(option.totalPrice)}`
                }}</span>
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.tipo === "servico" ? `Serviço: ${option.discriminacao}` : option.label }}
              </div>
            </template>
          </VueSelect>
        </b-form-group>
      </b-col>
      <b-col class="mt-1 d-flex align-items-center flex-nowrap orcamento-item-filters">
        <b-dropdown
          id="dropdown-dropright"
          dropright
          size="sm"
          variant="primary"
          v-b-tooltip.hover.right
          title="Mudar tipo de filtro"
        >
          <template #button-content>
            <FilterOutline :size="18" class="mt-" />
          </template>
          <b-dropdown-item
            @click="
              () => {
                typeFilter = 1;
              }
            "
            :class="typeFilter === 1 ? 'bg-primary' : ''"
          >
            <p :class="typeFilter === 1 ? 'text-white' : ''">Começando com</p>
          </b-dropdown-item>
          <b-dropdown-item
            @click="
              () => {
                typeFilter = 2;
              }
            "
            :class="typeFilter === 2 ? 'bg-primary' : ''"
          >
            <p :class="typeFilter === 2 ? 'text-white' : ''">Terminando com</p>
          </b-dropdown-item>
          <b-dropdown-item
            @click="
              () => {
                typeFilter = 3;
              }
            "
            :class="typeFilter === 3 ? 'bg-primary' : ''"
          >
            <p :class="typeFilter === 3 ? 'text-white' : ''">Contendo</p>
          </b-dropdown-item>
        </b-dropdown>
        <EstoqueGrupoProduto
          v-if="produtoSelected && produtoSelected.tipo !== 'servico'"
          :produto="produtoSelected"
        />
      </b-col>
      <b-col class="mt-1 orcamento-item-price-list">
        <b-button
          variant="primary"
          v-b-tooltip.hover.right
          title="Selecionar lista de preço"
          @click="$bvModal.show('modal-lista-preco')"
        >
          <TagOutline :size="20" class="mr-1" /> Lista
        </b-button>
      </b-col>

      <!-- NOVO: pill com a descrição e botão de remover -->
      <b-col
        class="mt-1 orcamento-selected-list"
        v-if="selectedLista && selectedLista.descricao"
        style="margin-bottom: 5px"
      >
        <div class="d-flex align-items-center">
          <span class="badge badge-light px-3 py-2">
            <strong>Lista de preço selecionada:</strong>
            {{ selectedLista.descricao }}
            <button
              type="button"
              class="btn btn-link text-danger p-0 ml-2"
              @click="selectedLista = null"
              title="Remover lista selecionada"
            >
              <CloseCircleOutline :size="18" />
            </button>
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row class="orcamento-item-values">
      <b-col cols="6" md>
        <b-form-group label="Quantidade" label-for="quantidade">
          <money
            class="form-control"
            ref="quantidade"
            id="quantidade"
            name="quantidade"
            v-model="quantidade"
            v-bind="quantityOptions"
            v-on:keyup.native.enter="handleEnter('preco')"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6" md>
        <b-form-group label="Unitário" label-for="preco">
          <money
            class="form-control"
            ref="preco"
            id="preco"
            name="preco"
            v-model="preco"
            v-bind="priceOptions"
            v-on:keyup.native.enter="handleEnter('desconto')"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6" md>
        <b-form-group label="Desconto" label-for="desconto">
          <b-input-group>
            <money
              v-if="descontoTipo === 'valor'"
              :key="'desconto-valor-' + descontoInputKey"
              class="form-control"
              ref="desconto"
              id="desconto"
              name="desconto"
              v-model="desconto"
              v-bind="configMask"
              v-on:keyup.native.enter="addProduto(produtoSelected)"
            />
            <b-form-input
              v-else
              :key="'desconto-percentual-' + descontoInputKey"
              ref="desconto"
              id="desconto"
              name="desconto"
              type="number"
              min="0"
              max="100"
              step="0.01"
              v-model.number="desconto"
              v-on:keyup.native.enter="addProduto(produtoSelected)"
            />
            <b-input-group-append>
              <b-button variant="light" @click="toggleDescontoTipo">
                {{ descontoTipo === "valor" ? "R$" : "%" }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col cols="6" md>
        <b-form-group label="Total R$" label-for="total">
          <money
            disabled
            class="form-control"
            id="total"
            name="total"
            v-model="total"
            v-bind="priceOptions"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6" md="auto" class="orcamento-add-item">
        <b-form-group label-for="add">
          <button class="orcamento-add-button" @click="addProduto(produtoSelected)">
            <Plus
              class="btn btn-sm btn-info btn-hover-info btn-icon mr-2 mt-9"
              v-if="windowWidth >= 992"
            />
            <button
              v-else
              class="btn btn-info btn-hover-dark font-weight-bolder font-size-lg orcamento-add-button-label"
            >
              Adicionar {{ produtoSelected && produtoSelected.tipo === "servico" ? "serviço" : "produto" }}
            </button>
          </button>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row class="orcamento-item-table">
      <b-col>
        <TableApp
          item="item"
          subTitulo=""
          :data="itensOrcamento"
          :fields="fieldsVisiveis"
          classFilterColumn="nome"
          ref="nome"
        >
          <template slot="customRow" scope="props">
            <span slot="item" class="pl-0 pt-8" v-if="props.field === 'item'">
              <div class="font-weight-bold text-muted">
                {{ props.rowData.numeroItem }} / {{ props.rowData.codigoItem }}
              </div>
            </span>
            <span slot="nome" class="pl-0 pt-8" v-if="props.field === 'descricao'">
              <span class="font-weight-bold text-muted">
                {{ props.rowData.nomeItem }}
                <span
                  v-if="props.rowData.tipo === 'produto' && props.rowData.product.tipo_atacado"
                  v-b-tooltip.hover.right="'Item atendeu a regra de preço de atacado'"
                ><InformationOutline :size="14" /></span>
              </span>
            </span>
            <span
              slot="tipo"
              v-if="props.field === 'tipo' && store.permitirServicosOrcamento"
            >
              <span
                class="tipo-badge"
                :class="props.rowData.tipo === 'servico' ? 'tipo-badge--servico' : 'tipo-badge--produto'"
              >{{ props.rowData.tipo === 'servico' ? 'Serviço' : 'Produto' }}</span>
            </span>
            <span slot="quantidade" class="pl-0 pt-8" v-if="props.field === 'quantidade'">
              <span class="font-weight-bold text-muted">{{ numberToReal(props.rowData.quantidadeItem, 'quantidade') }}</span>
            </span>
            <span slot="preco" class="pl-0 pt-8" v-if="props.field === 'preco'">
              <span class="font-weight-bold text-muted valor-monetario-orcamento">{{ numberToReal(props.rowData.unitarioItem, 'preco') }}</span>
            </span>
            <span slot="desconto" class="text-dark-75 font-weight-bolder d-block font-size-lg valor-monetario-orcamento" v-if="props.field === 'desconto'">
              R$ {{ numberToReal(props.rowData.descontoItem, props.rowData.tipo === 'servico' ? 'preco' : 2) }}
            </span>
            <span slot="total" class="text-dark-75 font-weight-bolder d-block font-size-lg valor-monetario-orcamento" v-if="props.field === 'total'">
              R$ {{ numberToReal(props.rowData.totalItem, 'preco') }}
            </span>
            <span slot="actions" v-if="props.field === 'actions'">
              <div class="row-actions" style="text-align: right !important">
                <div v-if="props.rowData.tipo === 'produto' || store.permitirServicosOrcamento" class="action-buttons">
                  <button type="button" class="btn btn-sm btn-info btn-hover-info btn-icon mr-2" title="Editar" @click="editarItem(props.rowData)">
                    <Pencil :size="16" />
                  </button>
                  <button type="button" class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2" title="Remover" @click="removerItem(props.rowData)">
                    <TrashCanIcon :size="16" />
                  </button>
                </div>
              </div>
            </span>
          </template>
        </TableApp>
        <b-row v-if="itensOrcamento.length > 0" class="orcamento-item-summary">
          <b-col></b-col>
          <b-col></b-col>
          <b-col><span class="text-primary font-weight-bolder">Total Itens:</span> {{ totalQuantidadeItens }}</b-col>
          <b-col><span class="text-primary font-weight-bolder">Total R$:</span> {{ numberToReal(totalGeralItens, 'preco') }}</b-col>
        </b-row>
        <ModalProduto
          :close="closeModalProduto"
          :changeProduto="saveEditProduto"
          :produto="produtoToEdit"
          :open="modalProdutoIsOpen"
          v-if="modalProdutoIsOpen"
        />
      </b-col>
    </b-row>

    <b-modal
      id="modal-lista-preco"
      title="Selecionar lista de preço"
      hide-footer
    >
      <b-form-group label="Lista de Preço">
        <VueSelect
          ref="pedido"
          :filterable="false"
          :options="listaDePrecos"
          v-model="selectedLista"
          @search="onSearchLista"
        >
          <template slot="no-options">Busque pela descrição</template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              {{ option.descricao }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              {{ option.descricao }}
            </div>
          </template>
        </VueSelect>
      </b-form-group>

      <div class="d-flex justify-content-between">
        <b-button
          variant="danger"
          @click="
            selectedLista = null;
            $bvModal.hide('modal-lista-preco');
          "
        >
          Cancelar
        </b-button>
        <b-button variant="primary" @click="$bvModal.hide('modal-lista-preco')">
          Aplicar
        </b-button>
      </div>
    </b-modal>
    <b-modal v-model="modalServicoIsOpen" title="Editar serviço" hide-footer>
      <template v-if="servicoParaEditar">
        <b-form-group label="Descrição"><b-form-input v-model="servicoParaEditar.discriminacao" /></b-form-group>
        <b-form-group label="Quantidade"><money class="form-control" v-model="servicoParaEditar.quantidade" v-bind="quantityOptions" /></b-form-group>
        <b-form-group label="Valor unitário"><money class="form-control" v-model="servicoParaEditar.unitario" v-bind="priceOptions" /></b-form-group>
        <b-form-group label="Desconto"><money class="form-control" v-model="servicoParaEditar.desconto" v-bind="configMask" /></b-form-group>
        <b-form-group label="Observação"><b-form-textarea v-model="servicoParaEditar.observacao" rows="3" /></b-form-group>
        <div class="text-right">
          <b-button variant="secondary" @click="closeModalServico">Fechar</b-button>
          <b-button variant="success" @click="saveEditServico">Gravar</b-button>
        </div>
      </template>
    </b-modal>
    <VariacaoProdutoModal
      :addProduto="addProdutoVariacao"
      :produto="produtoSelected"
      :preco="preco"
      :compra="false"
      @onAddProduto="onAddProdutoFromVariacao"
    />
    <LoteProdutoModal
      :addProduto="addProdutoLote"
      :produto="produtoSelected"
      :preco="preco"
      :atualizarLotes="atualizarLotes"
      @onAddProduto="onAddProdutoFromLote"
    />
  </b-tab>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
import VueSelect from "vue-select";
import { Money } from "v-money";
import {
  MONEY as settingMoney,
  priceOptions,
  quantityOptions,
} from "@/modules/Application";
import "vue-select/dist/vue-select.css";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import InformationOutline from "vue-material-design-icons/InformationOutline.vue";
import Plus from "vue-material-design-icons/PlusThick.vue";
import TableApp from "../../../../components/Table/Table3.vue";
import ModalProduto from "./ModalProduto.vue";
import { validationMixin } from "vuelidate";
import ProdutoData from "../ProdutoData";
import {
  SistemaMixin,
  ValidacaoMixin,
  FormatMixin,
} from "@/modules/Application";
import _ from "lodash";
import { mask } from "vue-the-mask";
import { store } from "../../storeOrcamento";
import FilterOutline from "vue-material-design-icons/Filter";
import VariacaoProdutoModal from "@/components/VariacaoProdutoModal";
import LoteProdutoModal from "@/components/LoteProdutoModal";
import TagOutline from "vue-material-design-icons/TagOutline.vue";
import CloseCircleOutline from "vue-material-design-icons/CloseCircleOutline.vue";
import EstoqueGrupoProduto from "@/modules/GrupoEmpresa/components/EstoqueGrupoProduto.vue";

export default {
  name: "app-orcamento-form-ProdutoTab",
  components: {
    VueSelect,
    ModalProduto,
    TableApp,
    Pencil,
    Plus,
    TrashCanIcon,
    Money,
    FilterOutline,
    InformationOutline,
    VariacaoProdutoModal,
    LoteProdutoModal,
    TagOutline,
    CloseCircleOutline,
    EstoqueGrupoProduto,
  },
  directives: {
    mask,
  },
  data() {
    return {
      store,
      configMask: settingMoney,
      priceOptions,
      quantityOptions,
      typeFilter: 3,
      windowWidth: window.innerWidth,
      fields: [
        {
          label: "Item/Cód",
          field: "item",
          slot: true,
          sortable: false,
          width: "5%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Nome",
          field: "descricao",
          slot: true,
          sortable: false,
          width: "40%",
          filterOptions: {
            enabled: false,
          },
        },
        {
          label: "Tipo",
          field: "tipo",
          slot: true,
          sortable: false,
          width: "10%",
        },
        {
          label: "Qtd",
          field: "quantidade",
          slot: true,
          sortable: false,
          width: "10%",
        },
        {
          label: "Unitário",
          field: "preco",
          sortable: false,
          slot: true,
          width: "10%",
        },
        {
          label: "Desconto",
          field: "desconto",
          sortable: false,
          slot: true,
          width: "20%",
        },
        {
          label: "Total",
          field: "total",
          sortable: false,
          slot: true,
          width: "20%",
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          slot: true,
          width: "20%",
        },
      ],
      form: {},
      descricao: "",
      quantidade: 1,
      preco: 0,
      desconto: 0,
      descontoTipo: "valor",
      descontoInputKey: 0,
      total: 0,
      fromSelect: false,
      precoSelecionadoNoModal: false,
      produtoSelected: null,
      estoqueProduto: 0,
      produtosFetched: [],
      produtos: [],
      produtoToEdit: null,
      modalProdutoIsOpen: false,
      dataSendToApi: {},
      produtoError: false,
      produtoFilled: false,
      atualizarLotes: 0,
      selectedLista: null,
      listaDePrecos: [],
      modalServicoIsOpen: false,
      servicoParaEditar: null,
    };
  },
  mixins: [validationMixin, SistemaMixin, ValidacaoMixin, FormatMixin],
  validations() {
    return {
      form: {
        produtos: {
          required: (produtos) => !!produtos?.length || !!this.store.formServicos.length,
        },
      },
    };
  },
  watch: {
    form(newValue) {
      this.store.formProduto = newValue;
    },
    "store.currentTab"(newValue, oldValue) {
      if (
        newValue !== oldValue &&
        newValue === this.produtoTabIndex + 1 &&
        oldValue < newValue
      ) {
        this.$v.form.$touch();
        if (this.$v.form.$anyError) {
          this.$toast.error("Necessario incluir um produto");
          this.produtoError = true;
          this.store.currentTab = oldValue;
          return;
        }
      }
    },
    preco(newValue, oldValue) {
      if (oldValue !== newValue) {
        this.updateTotalProduto();
      }
    },
    quantidade(newValue, oldValue) {
      if (oldValue !== newValue) {
        if (!this.produtoSelected || this.produtoSelected.tipo === "servico") {
          this.updateTotalProduto();
          return;
        }
        const isAtacado =
          !this.precoSelecionadoNoModal &&
          newValue >= this.produtoSelected.quantidade_atacado &&
          this.produtoSelected.preco_atacado > 0 &&
          this.store.formCliente.tipo_atacado;

        // Preserva o preço confirmado no modal ao atualizar a quantidade.
        if (!this.precoSelecionadoNoModal) {
          this.preco = isAtacado
            ? this.formatNumberToFloat(this.produtoSelected.preco_atacado)
            : this.produtoSelected.preco;
        }

        this.updateTotalProduto();
        this.produtoSelected.total = this.total;
        this.produtoSelected.tipo_atacado = isAtacado;
        this.produtoSelected.quantidade = newValue;
      }
    },
    desconto(newValue, oldValue) {
      if (oldValue !== newValue && !isNaN(newValue) && newValue !== "") {
        this.updateTotalProduto();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    ...mapActions(["setLoading"]),
    totalServicos() {
      return (this.store.formServicos || []).reduce(
        (total, servico) => total + Number(servico.total || 0),
        0
      );
    },
    valoresValidos(quantidade, unitario, desconto) {
      return Number.isFinite(quantidade) && quantidade > 0 &&
        Number.isFinite(unitario) && unitario > 0 &&
        Number.isFinite(desconto) && desconto >= 0 &&
        desconto < quantidade * unitario;
    },
    atualizarTotais() {
      const totalProdutos = (this.form.produtos || []).reduce(
        (total, produto) => total + Number(produto.quantity) * Number(produto.price) - Number(produto.discount || 0), 0
      );
      this.form = {
        ...this.form,
        subtotal: Number((totalProdutos + this.totalServicos()).toFixed(2)),
      };
      this.store.formFaturamento.pagamentos = [];
    },
    addServico() {
      if (!this.store.permitirServicosOrcamento || this.produtoSelected?.tipo !== "servico") return;
      const quantidade = Number(this.quantidade);
      const unitario = Number(this.preco);
      const desconto = this.getDescontoProdutoEmReais();
      if (!this.valoresValidos(quantidade, unitario, desconto)) {
        this.$toast.warning("Verifique quantidade, valor e desconto do serviço.");
        return;
      }
      const servico = this.produtoSelected;
      this.store.formServicos = [
        ...this.store.formServicos,
        {
          ...servico,
          tipo: "servico",
          chave_item: `servico:${servico.id_servico}`,
          id_servico: servico.id_servico,
          discriminacao: servico.discriminacao,
          quantidade,
          unitario,
          desconto,
          total: Number((quantidade * unitario - desconto).toFixed(2)),
          horimetro_dados: null,
        },
      ];
      this.atualizarTotais();
      this.clearFields();
      this.produtoError = false;
      this.$nextTick(() => this.$refs.buscarProduto.$refs.search.focus());
    },
    editarItem(item) {
      if (item.tipo === "servico") {
        this.openModalServico(item);
      } else {
        this.openModalProduto(item, item.currentIndex);
      }
    },
    removerItem(item) {
      if (item.tipo === "servico") {
        this.removerServico(item.indiceServico);
      } else {
        this.handleDeleteProduto(item);
      }
    },
    openModalServico(servico) {
      this.servicoParaEditar = {
        ..._.cloneDeep(servico),
        originalIndex: servico.indiceServico,
      };
      this.modalServicoIsOpen = true;
    },
    closeModalServico() {
      this.modalServicoIsOpen = false;
      this.servicoParaEditar = null;
    },
    saveEditServico() {
      if (!this.servicoParaEditar) return;
      const { originalIndex, discriminacao, quantidade, unitario, desconto, observacao } = this.servicoParaEditar;
      if (!String(discriminacao || "").trim()) {
        this.$toast.warning("Informe a descrição do serviço.");
        return;
      }
      if (!this.atualizarServico(originalIndex, {
        discriminacao,
        quantidade: Number(quantidade),
        unitario: Number(unitario),
        desconto: Number(desconto || 0),
        observacao,
      })) return;
      this.closeModalServico();
      this.$toast.success("Serviço editado com sucesso!");
    },
    atualizarServico(index, alteracoes) {
      const servico = { ...this.store.formServicos[index], ...alteracoes };
      const quantidade = Number(servico.quantidade);
      const unitario = Number(servico.unitario);
      const desconto = Number(servico.desconto || 0);
      if (!this.valoresValidos(quantidade, unitario, desconto)) {
        this.$toast.warning("Verifique quantidade, valor e desconto do serviço.");
        return false;
      }
      servico.total = Number((quantidade * unitario - desconto).toFixed(2));
      this.$set(this.store.formServicos, index, servico);
      this.atualizarTotais();
      return true;
    },
    removerServico(index) {
      this.store.formServicos.splice(index, 1);
      this.atualizarTotais();
    },
    onSearchLista(search, loading) {
      loading(true);
      this.searchLista(loading, search, this);
    },
    searchLista: _.debounce(async (loading, search, vm) => {
      vm.listaDePrecos = [];
      await vm.$nextTick();
      if (!search) {
        loading(false);
        return;
      }
      const response = await vm.$http.post("/produtos/get-lista-preco-geral", {
        descricao: search,
      });
      vm.listaDePrecos = _.cloneDeep(response.data);
      loading(false);
    }, 500),
    handleEnter(ref) {
      if (this.fromSelect) {
        this.fromSelect = false;
        return;
      }
      if (!this.$refs[ref]) return;
      this.$refs[ref].$el.focus();

      let inputEl = this.$refs[ref].$el;

      setTimeout(() => {
        inputEl.select();
      }, 100);
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    toggleDescontoTipo() {
      this.descontoTipo =
        this.descontoTipo === "valor" ? "percentual" : "valor";
      this.desconto = 0;
      this.updateTotalProduto();
      this.descontoInputKey++;
    },
    getDescontoProdutoEmReais() {
      const desconto = parseFloat(this.desconto) || 0;

      if (this.descontoTipo === "percentual") {
        return this.roundTo2Digits((this.quantidade * this.preco * desconto) / 100);
      }

      return this.roundTo2Digits(desconto);
    },
    updateTotalProduto() {
      const subtotal = this.quantidade * this.preco;
      this.total = this.roundTo2Digits(subtotal - this.getDescontoProdutoEmReais());
    },
    async addProduto(produto, isKit) {
      if (_.isEmpty(produto)) return;
      if (produto.tipo === "servico") {
        this.addServico();
        return;
      }

      if (produto.variavel && !produto.combinacao) {
        this.$toast.warning("Produto sem variação informada!");
        return;
      }

      if (
        !isKit &&
        this.reservaCondicionalUltrapassada(
          produto,
          this.quantidade,
          this.produtos
        )
      ) {
        return false;
      }

      if (!await this.validarReservaPedidos(
        produto, isKit ? (produto.quantity ?? produto.quantidade) : this.quantidade, this.produtos
      )) return false;

      const descontoEmReais = this.getDescontoProdutoEmReais();
      const produtoFormatted = !isKit
        ? {
            ...produto,
            tipo: "produto",
            chave_item: `produto:${produto.id ?? produto.id_produto}`,
            preco: this.preco,
            quantidade: this.quantidade,
            desconto: descontoEmReais,
            total: this.total,
          }
        : { ...produto };
      this.produtos = [
        ...this.produtos,
        !isKit
          ? {
              product: produtoFormatted,
              tipo: "produto",
              chave_item: produtoFormatted.chave_item,
              price: this.preco,
              quantity: this.quantidade,
              totalPrice: this.total,
              discount: descontoEmReais,
              active: true,
              currentIndex: this.produtos.length,
              ...(produto.variavel && { combinacao: produto.combinacao }),
            }
          : {
              ...produto,
              product: { ...produto },
              ...(produto.variavel && { combinacao: produto.combinacao }),
            },
      ];

      const subtotal = this.produtos.reduce(
        (acc, produto) =>
          acc + (produto.quantity * produto.price - produto.discount),
        0
      );
      this.form = {
        produtos: [...this.produtos],
        subtotal: subtotal + this.totalServicos(),
      };

      this.clearFields();
      this.store.formFaturamento.pagamentos = [];
      if (this.store.formFaturamento.forma_pagamento.descricao === "Nenhum") {
        this.store.formFaturamento.pagamentos[0].valor =
          this.store.formImpostos.totalNFE;
      }

      this.produtoError = false;
      this.$nextTick(() => {
        this.$refs.buscarProduto.$refs.search.focus();
      });
    },
    clearFields() {
      this.precoSelecionadoNoModal = false;
      this.descricao = "";
      this.estoqueProduto = 0;
      this.quantidade = 1;
      this.preco = 0;
      this.total = 0;
      this.desconto = 0;
      this.produtoSelected = null;
      this.produtoFilled = false;
    },
    addProdutoVariacao(produto) {
      // Função wrapper para o modal de variação
      // Garante que a descrição inclui a variação antes de adicionar
      if (produto?.combinacao) {
        const descricaoBase = this.produtoSelected?.descricao || produto.descricao;
        
        // Constrói a string da combinação a partir do objeto
        const combinacaoString = [];
        for (const key in produto.combinacao) {
          if (key !== 'quantidade' && produto.combinacao[key]) {
            combinacaoString.push(produto.combinacao[key]);
          }
        }
        
        if (combinacaoString.length > 0) {
          produto.descricao = `${descricaoBase} - ${combinacaoString.join('/')}`;
        }
      }
      this.addProduto(produto);
    },
    addProdutoLote(produto) {
      // Função wrapper para o modal de lote
      // Garante que a descrição inclui o lote antes de adicionar
      if (produto?.lote_baixa) {
        const descricaoBase = this.produtoSelected?.descricao || produto.descricao;
        const lote = produto.lote_baixa;
        produto.descricao = `${descricaoBase} - Nº do Lote: ${lote.numero_lote} / Dt Validade: ${this.formatDate(lote.data_validade)}`;
      }
      this.addProduto(produto);
    },
    onAddProdutoFromVariacao({ newPreco, newQuantidade, newTotal, newProduto }) {
      // Handler do evento @onAddProduto do modal de variação
      this.precoSelecionadoNoModal = true;
      this.preco = this.formatNumberToFloat(newPreco);
      this.quantidade = newQuantidade;
      this.total = newTotal;
      
      const descricaoBase = this.produtoSelected?.descricao || newProduto.descricao;
      
      // Constrói a string da combinação a partir do objeto
      if (newProduto?.combinacao) {
        const combinacaoString = [];
        for (const key in newProduto.combinacao) {
          if (key !== 'quantidade' && newProduto.combinacao[key]) {
            combinacaoString.push(newProduto.combinacao[key]);
          }
        }
        
        if (combinacaoString.length > 0) {
          newProduto.descricao = `${descricaoBase} - ${combinacaoString.join('/')}`;
        }
      }
      
      this.addProduto(newProduto);
    },
    onAddProdutoFromLote({ newPreco, newQuantidade, newTotal, newProduto }) {
      // Handler do evento @onAddProduto do modal de lote
      this.preco = this.formatNumberToFloat(newPreco);
      this.quantidade = newQuantidade;
      this.total = newTotal;
      
      const descricaoBase = this.produtoSelected?.descricao || newProduto.descricao;
      
      // Adiciona informações do lote à descrição
      if (newProduto?.lote_baixa) {
        const lote = newProduto.lote_baixa;
        newProduto.descricao = `${descricaoBase} - Nº do Lote: ${lote.numero_lote} / Dt Validade: ${this.formatDate(lote.data_validade)}`;
      }
      
      this.addProduto(newProduto);
    },
    openModalProduto({ product }, currentIndex) {
      this.modalProdutoIsOpen = true;
      this.produtoToEdit = {
        ...product,
        currentIndex,
      };
    },
    handleDeleteProduto(item) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir o produto " + item.product.descricao + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            const aux = this.produtos
              .filter((produto) => produto.currentIndex !== item.currentIndex)
              .map((item, index) => ({
                ...item,
                currentIndex: index,
              }));
            this.form.produtos = [...aux];
            this.produtos = [...aux];
            const subtotal = this.produtos.reduce(
              (acc, produto) =>
                acc + (produto.quantity * produto.price - produto.discount),
              0
            );
            this.form = {
              produtos: [...this.produtos],
              subtotal: subtotal + this.totalServicos(),
            };
            this.store.formFaturamento.pagamentos = [];
            if (
              this.store.formFaturamento.forma_pagamento.descricao === "Nenhum"
            ) {
              this.store.formFaturamento.pagamentos[0].valor =
                this.store.formImpostos.totalNFE;
            }
          }
        });
    },
    closeModalProduto() {
      this.modalProdutoIsOpen = false;
    },
    setDesconto() {
      if (!this.produtoSelected) return;
      this.form.total =
        this.form.preco * this.form.quantidade - this.form.desconto;
      this.produtoSelected.total =
        parseFloat(this.produtoSelected.preco) *
          parseFloat(this.produtoSelected.quantidade) -
        this.produtoSelected.desconto;
    },
    validateProdutoState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async saveEditProduto(newEditedProduto) {
      if (
        this.reservaCondicionalUltrapassada(
          newEditedProduto,
          newEditedProduto.quantidade,
          this.form.produtos,
          newEditedProduto.currentIndex
        )
      ) {
        return;
      }

      if (!await this.validarReservaPedidos(
        newEditedProduto, newEditedProduto.quantidade, this.form.produtos, newEditedProduto.currentIndex
      )) return;

      this.form.produtos[newEditedProduto.currentIndex] = {
        ...this.form.produtos[newEditedProduto.currentIndex],
        product: newEditedProduto,
        price: newEditedProduto.preco,
        quantity: newEditedProduto.quantidade,
        totalPrice:
          newEditedProduto.preco * newEditedProduto.quantidade -
          parseFloat(newEditedProduto.desconto),
        discount: parseFloat(newEditedProduto.desconto),
      };
      this.form.subtotal = this.form.produtos.reduce(
        (acc, produto) =>
          acc + produto.price * produto.quantity - produto.discount,
        0
      ) + this.totalServicos();
      this.produtos = _.cloneDeep(this.form.produtos);
      this.store.formProduto = _.cloneDeep(this.form);
      this.modalProdutoIsOpen = false;
    },
    onSearchProduto(search, loading) {
      if (search.length > 1 && search[0] === "+") {
        loading(true);
        this.searchKit(loading, search, this);
        return;
      }
      if (search.length > 2 || /^[0-9]+$/.test(search)) {
        loading(true);
        this.searchProdutos(loading, search, this);
      }
    },
    searchProdutos: _.debounce(async (loading, search, vm) => {
      try {
        const { data } = await vm.$http.post("/produtos/filter-item", {
          filter: search,
          typeFilter: vm.typeFilter,
          orcamento: true,
          ...(vm.store?.formCliente?.id_pessoa && { id_pessoa: vm.store.formCliente.id_pessoa }),
          ...(vm.selectedLista && { lista_selecionada: vm.selectedLista }),
        });
        vm.produtosFetched = data;
      } catch (error) {
        vm.produtosFetched = [];
        vm.$toast.error("Erro ao buscar itens do orçamento");
      } finally {
        loading(false);
      }
    }, 350),
    searchKit: _.debounce(async (loading, search, vm) => {
      const { data } = await vm.$http.post("/kit/get-kit", { search });
      vm.produtosFetched = data.map((kit) => ({
        ...kit,
        descricao: kit.nome,
        isKit: true,
        tipo: "produto",
        chave_item: `produto:${kit.id}`,
      }));
      loading(false);
    }, 350),
    getKitInfo(kitData) {
      // Kit com unidade de medida propria: mostra o resumo do fardo/caixa.
      if (kitData.usar_unidade_medida) {
        const unidade = kitData.unidade_medida || {};
        const base = kitData.productOfTradeCollection?.[0]?.product || {};
        const conversor = parseFloat(unidade.conversor) || 0;
        return `1 ${unidade.sigla || ""} de ${base.descricao || ""}` +
          (conversor ? ` (${conversor} ${base.unidade_medida?.sigla || "un"})` : "") +
          ` - R$ ${this.numberToReal(kitData.valor_unitario, "preco")}`;
      }
      const description = kitData.productOfTradeCollection.reduce(
        (acc, produto, index) =>
          acc +
          `${index + 1} - ${produto.product.descricao} - QTD: ${
            produto.product.quantidade
          }<br/>`,
        ""
      );
      return description;
    },
    getItemKey(item) {
      return item.chave_item || `${item.tipo === "servico" ? "servico" : "produto"}:${item.id_servico ?? item.id}`;
    },
    async setProduto(produto) {
      if (!produto) return;
      this.precoSelecionadoNoModal = false;
      if (produto.tipo === "servico") {
        this.descricao = produto.discriminacao;
        this.quantidade = 1;
        this.preco = Number(produto.valor || 0);
        this.desconto = 0;
        this.produtoSelected = produto;
        this.updateTotalProduto();
        this.produtoFilled = true;
        this.$nextTick(() => this.$refs.quantidade.$el.focus());
        return;
      }
      this.descricao = produto.descricao;

      if (produto?.variavel) {
        this.produtoSelected = produto;
        this.$bvModal.show("variacaoModal");
        return;
      }

      if (produto?.lote) {
        this.estoqueProduto = produto.quantidade;
        const preco_atacado = produto?.preco_atacado ?? 0;
        const qtd_atacado = produto?.quantidade_atacado ?? 0;
        this.quantidade = 1;

        const isAtacadoValue =
          this.quantidade >= qtd_atacado &&
          preco_atacado > 0 &&
          this.store.formCliente.tipo_atacado;

        if (isAtacadoValue) {
          this.preco = parseFloat(preco_atacado);
        } else this.preco = parseFloat(produto.preco);

        if (parseFloat(produto?.preco_lista_cliente ?? 0) > 0) {
          this.preco = parseFloat(produto.preco_lista_cliente);
        }

        this.total = this.quantidade * parseFloat(this.preco);

        this.produtoSelected = {
          ...produto,
          preco: this.preco,
          quantidade: this.quantidade,
          tipo_atacado: isAtacadoValue,
        };
        this.produtoSelected.total = this.total;
        this.produtoSelected.quantidade_original = produto.quantidade;

        this.atualizarLotes++;

        this.$nextTick(() => {
          this.$bvModal.show("loteModal");
        });

        this.produtosFetched = [];
        return;
      }

      if (produto?.isKit) {
        // Kit com unidade de medida propria (fardo, caixa...): lança como
        // 1 item unico, herdando os dados fiscais do produto base.
        if (produto.usar_unidade_medida) {
          const base = produto.productOfTradeCollection?.[0]?.product || {};
          const kitUnidade = produto.unidade_medida || null;
          const valorUnitario = parseFloat(produto.valor_unitario || 0);
          // A descricao comercial eh o nome do kit ("Fardo de mouse").
          const descricaoKit =
            produto.nome ||
            `${kitUnidade?.nome || "Kit"} de ${base.descricao || ""}`;

          // Busca o estoque REAL atual do produto base.
          let baseAtualizada = { ...base };
          try {
            const { data: produtoBase } = await this.$http.post(
              "/produtos/find",
              { id: base.id }
            );
            const produtoData = produtoBase?.data ?? produtoBase;
            if (produtoData) {
              baseAtualizada = {
                ...base,
                quantidade: produtoData.quantidade,
                quantidade_original: produtoData.quantidade,
                quantidade_reservada: produtoData.quantidade_reservada,
                quantidade_disponivel: produtoData.quantidade_disponivel,
                quantidade_reservada_condicional:
                  produtoData.quantidade_reservada_condicional,
              };
            }
          } catch (e) {
            console.log("[KIT-UNIDADE] falha ao buscar estoque do produto base", e);
          }

          const produtoToAdd = {
            ...baseAtualizada,
            descricao: descricaoKit,
            price: valorUnitario,
            quantity: 1,
            totalPrice: valorUnitario,
            discount: baseAtualizada?.desconto ?? 0,
            active: true,
            currentIndex: 0,
            isKitUnidade: true,
            kit_unidade_medida: kitUnidade,
          };
          this.addProduto(produtoToAdd, true);
          return;
        }

        produto.productOfTradeCollection.forEach((product, index) => {
          const produtoToAdd = {
            ...product.product,
            price: product.product.preco,
            quantity: product.product.quantidade,
            totalPrice: product.product.total,
            discount: product.product?.desconto ?? 0,
            active: true,
            currentIndex: index,
          };
          this.addProduto(produtoToAdd, true);
        });
        return;
      }
      this.estoqueProduto = produto.quantidade;
      const preco_atacado = produto?.preco_atacado ?? 0;
      const qtd_atacado = produto?.quantidade_atacado ?? 0;
      this.quantidade = 1;

      const isAtacadoValue =
        this.quantidade >= qtd_atacado &&
        preco_atacado > 0 &&
        this.store.formCliente.tipo_atacado;

      if (isAtacadoValue) {
        this.preco = parseFloat(preco_atacado);
      } else this.preco = parseFloat(produto.preco);

      if (parseFloat(produto?.preco_lista_cliente ?? 0) > 0) {
        this.preco = parseFloat(produto.preco_lista_cliente);
      }

      this.total = this.quantidade * parseFloat(this.preco);

      this.produtoSelected = {
        ...produto,
        preco: this.preco,
        quantidade: this.quantidade,
        tipo_atacado: isAtacadoValue,
      };
      this.produtoSelected.total = this.total;
      this.produtoSelected.quantidade_original = produto.quantidade;

      this.produtoFilled = true;
      this.fromSelect = true;
      this.$nextTick(() => {
        this.$refs.quantidade.$el.focus();
        let inputEl = this.$refs.quantidade.$el;
        setTimeout(() => {
          inputEl.select();
        }, 100);
      });
    },
  },
  created() {
    if (Object.keys(this.$route.params).length !== 0) {
      const { produtos } = this.$route.params.orcamentoData;

      this.produtos = produtos.map((produto) => {
        const chaveItem = `produto:${produto.product.id ?? produto.product.id_produto}`;
        const produtoFormatted = {
          ...produto.product,
          tipo: "produto",
          chave_item: chaveItem,
          preco: produto.product.preco,
          quantidade: produto.product.quantidade,
          desconto: produto.product.desconto,
          total: produto.product.total,
        };
        return {
          product: produtoFormatted,
          tipo: "produto",
          chave_item: chaveItem,
          price: produto.price,
          quantity: produto.quantity,
          totalPrice: produto.totalPrice,
          discount: produto.discount,
          active: produto.active,
          currentIndex: produto.currentIndex,
        };
      });
      const subtotal = this.produtos.reduce(
        (acc, produto) =>
          acc + (produto.quantity * produto.price - produto.discount),
        0
      );
      this.form = {
        produtos: [...this.produtos],
        subtotal: subtotal + this.totalServicos(),
      };
    } else {
      this.form = new ProdutoData({});
      this.form.produtos = [];
    }
  },
  computed: {
    fieldsVisiveis() {
      return this.store.permitirServicosOrcamento
        ? this.fields
        : this.fields.filter((field) => field.field !== "tipo");
    },
    itensOrcamento() {
      const produtos = this.produtos.map((produto, index) => ({
        ...produto,
        tipo: "produto",
        numeroItem: index + 1,
        codigoItem: produto.product.codigo,
        nomeItem: produto.product.descricao,
        quantidadeItem: produto.quantity,
        unitarioItem: produto.price,
        descontoItem: produto.discount,
        totalItem: Number(produto.quantity) * Number(produto.price) - Number(produto.discount || 0),
      }));
      const servicos = this.servicos.map((servico, index) => ({
        ...servico,
        tipo: "servico",
        numeroItem: produtos.length + index + 1,
        codigoItem: servico.id_servico,
        nomeItem: servico.discriminacao,
        quantidadeItem: servico.quantidade,
        unitarioItem: servico.unitario,
        descontoItem: servico.desconto || 0,
        totalItem: servico.total,
        indiceServico: index,
      }));
      return [...produtos, ...servicos];
    },
    totalQuantidadeItens() {
      return this.itensOrcamento.reduce(
        (total, item) => total + Number(item.quantidadeItem || 0), 0
      );
    },
    totalGeralItens() {
      return this.itensOrcamento.reduce(
        (total, item) => total + Number(item.totalItem || 0), 0
      );
    },
    servicos() {
      return (this.store.formServicos || []).map((servico, index) => ({
        ...servico,
        tipo: "servico",
        chave_item: `servico:${servico.id_servico}`,
        originalIndex: index,
      }));
    },
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === this.produtoTabIndex;
    },
    produtoTabIndex() {
      return store.apresentarObjetoIdentificador ? 2 : 1;
    },
  },
};
</script>

<style scoped>
.tipo-badge {
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 0.42rem;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
}

.tipo-badge--produto {
  background-color: #e1f0ff;
  color: #187de4;
}

.tipo-badge--servico {
  background-color: #fff4de;
  color: #805400;
}

.valor-monetario-orcamento {
  min-width: 5.5rem;
  text-align: right;
  white-space: nowrap;
}

.valor-monetario-orcamento:not(.d-block) {
  display: inline-block;
  width: 100%;
}

@media (max-width: 991.98px) {
  .orcamento-item-search > .col-md-10 {
    flex: 0 0 100%;
    max-width: 100%;
    min-width: 0;
  }

  .orcamento-item-search .orcamento-item-filters,
  .orcamento-item-search .orcamento-item-price-list {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }

  .orcamento-item-search .orcamento-item-filters {
    flex-wrap: wrap !important;
  }

  .orcamento-item-search .orcamento-selected-list {
    flex: 0 0 100%;
    max-width: 100%;
    min-width: 0;
  }

  .orcamento-selected-list .badge {
    max-width: 100%;
    white-space: normal;
  }

  .orcamento-item-search ::v-deep .v-select,
  .orcamento-item-search ::v-deep .vs__dropdown-menu {
    max-width: 100%;
  }

  .orcamento-item-search ::v-deep .vs__selected-options,
  .orcamento-item-search ::v-deep .vs__dropdown-option .d-flex > div {
    min-width: 0;
  }

  .orcamento-item-search ::v-deep .vs__selected {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .orcamento-item-search ::v-deep .vs__dropdown-option {
    white-space: normal;
  }

  .orcamento-item-search ::v-deep .vs__dropdown-option .d-flex > div {
    overflow-wrap: anywhere;
  }

  .orcamento-item-values > .col-6,
  .orcamento-item-values .input-group,
  .orcamento-item-values .form-control {
    min-width: 0;
  }

  .orcamento-item-values .orcamento-add-item {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .orcamento-add-button {
    display: block;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    text-align: left;
  }

  .orcamento-add-button-label {
    width: 100%;
    margin: 0;
    white-space: normal;
  }

  .orcamento-item-table > .col,
  .orcamento-item-table ::v-deep .card-body,
  .orcamento-item-table ::v-deep .tab-content,
  .orcamento-item-table ::v-deep .vgt-wrap,
  .orcamento-item-table ::v-deep .vgt-inner-wrap {
    min-width: 0;
    max-width: 100%;
  }

  .orcamento-item-table ::v-deep .card-body {
    padding-right: 8px;
    padding-left: 8px;
  }

  .orcamento-item-table ::v-deep .table-responsive,
  .orcamento-item-table ::v-deep .vgt-responsive {
    width: 100%;
    min-width: 0;
    max-width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .orcamento-item-table ::v-deep table.vgt-table {
    width: 100%;
    min-width: 850px;
    max-width: none;
  }

  .orcamento-item-summary {
    justify-content: flex-end;
    gap: 8px;
  }

  .orcamento-item-summary > .col:nth-child(-n + 2) {
    display: none;
  }

  .orcamento-item-summary > .col:nth-child(n + 3) {
    flex: 0 0 auto;
    max-width: 100%;
    white-space: nowrap;
  }
}

@media (max-width: 374.98px) {
  .orcamento-item-values > .col-6:not(.orcamento-add-item) {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>
